// File: App.js
import React from 'react';
import ScrollReveal from '../../components/ScrollReveal';
import { useLanguage } from '../../contexts/LanguageContext';

type ItemProps = {
    img: string;
    title: string;
    description: string;
};

const ItemProps: React.FC<ItemProps> = ({ img, title, description }) => (
    <div className="flex flex-col items-start text-left max-w-xs">
        <h3 className="text-md text-white font-encode  mb-2">{title}</h3>
        <img
            src={img}
            alt={title}
            className="rounded-xl   w-full h-40 object-cover mb-4"
        />
        <p className="text-white/70 text-sm">{description}</p>
    </div>
);


const Services = () => {
    const { tString } = useLanguage();
    return (
        <section
            id='servicios'
            className="w-screen flex items-center justify-center  px-16 py-12"
            style={{
                backgroundColor: '#282A2A',
                backgroundImage: `
                    radial-gradient(ellipse 80% 60% at center, transparent 100%, #282A2A 80%),
                    url('/images/pattern.png')
                `,
                backgroundSize: 'auto',
                backgroundRepeat: 'repeat',
            }}
        >
            <div className="w-screen flex items-center justify-center py-16 max-w-7xl">


                {/* DATA */}
                <div className="w-full text-center">

                    <div className='text-center justify-center max-w-3xl mx-auto'>
                        <ScrollReveal direction="fade" delay={0.2}>
                            <h1 className="text-3xl font-encode font-bold text-[#ffffff] mb-4">
                                {tString('services.title')}
                            </h1>
                        </ScrollReveal>
                        <ScrollReveal direction="up" delay={0.4}>
                            <p className="text-[#ffffff]/80 text-md text-light mb-8 ">
                                {tString('services.description')}
                            </p>
                        </ScrollReveal>
                    </div>


                    <ScrollReveal direction="left" delay={0.5}>
                        <h1 className="text-3xl font-encode font-bold text-[#1DB233] mb-4 text-left">
                            {tString('services.nationalTitle')}
                        </h1>
                    </ScrollReveal>

                    {/* GRID */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                        <ScrollReveal direction="up" delay={0.6}>
                            <ItemProps
                                img="/images/cajas.png"
                                title={tString('services.nationalServices.cajas.title')}
                                description={tString('services.nationalServices.cajas.description')}
                            />
                        </ScrollReveal>
                        <ScrollReveal direction="up" delay={0.7}>
                            <ItemProps
                                img="/images/containers.jpg"
                                title={tString('services.nationalServices.plataformas.title')}
                                description={tString('services.nationalServices.plataformas.description')}
                            />
                        </ScrollReveal>
                        <ScrollReveal direction="up" delay={0.8}>
                            <ItemProps
                                img="/images/dimention.jpeg"
                                title={tString('services.nationalServices.sobredimensionado.title')}
                                description={tString('services.nationalServices.sobredimensionado.description')}
                            />
                        </ScrollReveal>
                        <ScrollReveal direction="up" delay={0.9}>
                            <ItemProps
                                img="/images/almacen.jpg"
                                title={tString('services.nationalServices.almacen.title')}
                                description={tString('services.nationalServices.almacen.description')}
                            />
                        </ScrollReveal>
                    </div>

                    <br /><br />

                    <ScrollReveal direction="left" delay={1.0}>
                        <h1 className="text-3xl font-encode font-bold text-[#1DB233] mb-4 text-left">
                            {tString('services.internationalTitle')}
                        </h1>
                    </ScrollReveal>

                    {/* GRID */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                        <ScrollReveal direction="up" delay={1.05}>
                            <ItemProps
                                img="/images/airplane.jpg"
                                title={tString('services.internationalServices.aereo.title')}
                                description={tString('services.internationalServices.aereo.description')}
                            />
                        </ScrollReveal>
                        <ScrollReveal direction="up" delay={1.1}>
                            <ItemProps
                                img="/images/boat.jpg"
                                title={tString('services.internationalServices.maritimo.title')}
                                description={tString('services.internationalServices.maritimo.description')}
                            />
                        </ScrollReveal>
                        <ScrollReveal direction="up" delay={1.15}>
                            <ItemProps
                                img="/images/intro_truck.png"
                                title={tString('services.internationalServices.terrestre.title')}
                                description={tString('services.internationalServices.terrestre.description')}
                            />
                        </ScrollReveal>
                        <ScrollReveal direction="up" delay={1.2}>
                            <ItemProps
                                img="/images/ports.jpg"
                                title={tString('services.internationalServices.puertos.title')}
                                description={tString('services.internationalServices.puertos.description')}
                            />
                        </ScrollReveal>
                    </div>



                </div>


            </div>


        </section >
    );
};

export default Services;